import { ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { PaveExplicatifTogglerDirective } from '../pave-explicatif-toggler.directive';
import { MatIcon } from "@angular/material/icon";
import { MatIconButton } from "@angular/material/button";

@Component({
  selector: 'lib-pegase-pave-explicatif-toggler',
  templateUrl: './pave-explicatif-toggler.component.html',
  styleUrls: ['./pave-explicatif-toggler.component.scss'],
  exportAs: 'toggler',
  imports: [
    MatIcon,
    MatIconButton,
    PaveExplicatifTogglerDirective
  ],
  standalone: true
})
export class PaveExplicatifTogglerComponent {
  @ViewChild(PaveExplicatifTogglerDirective, { read: PaveExplicatifTogglerDirective, static: true }) directive!: PaveExplicatifTogglerDirective;
}
